/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `card` - Card
 * * `cash` - Cash
 * * `mia` - Mia
 * * `cash_mia` - Cash Mia
 * * `pos` - Pos
 * * `broker_settlement` - Broker Settlement
 * * `bank_transfer` - Bank Transfer
 * * `credit` - Internal credit
 * * `manual` - Manual
 */
export enum PaymentTypeAll {
  CARD = 'card',
  CASH = 'cash',
  MIA = 'mia',
  CASH_MIA = 'cash_mia',
  POS = 'pos',
  BROKER_SETTLEMENT = 'broker_settlement',
  BANK_TRANSFER = 'bank_transfer',
  CREDIT = 'credit',
  MANUAL = 'manual',
}
